module.exports = __webpack_public_path__ + "static/media/small-logo.ed180861.svg";